import Styles from './DataMarquee.module.css'

export type DataMarqueeEventType =
  | 'pull_request_opened'
  | 'pull_request_merged'
  | 'repository_forked'
  | 'repository_starred'
  | 'push'

export interface DataMarqueeEvent {
  type: 'event'
  data: {
    type: DataMarqueeEventType
    actorLogin: string
    repositoryNameWithOwner: string
    timestamp: string
    url: string
  }
}

export interface DataMarqueeStat {
  type: 'stat'
  data: {
    value: string
    label: string
  }
}

export type DataMarqueeEventData = Omit<DataMarqueeEvent, 'type'>
export type DataMarqueeStatData = Omit<DataMarqueeStat, 'type'>

export interface DataMarqueeProps {
  items: Array<DataMarqueeEvent | DataMarqueeStat>
  copy: {
    events: {
      labelTemplate: Record<DataMarqueeEventType, string>
    }
  }
  a11y: {
    play: string
    pause: string
  }
}

export const defaultProps: Partial<DataMarqueeProps> = {}

export const DataMarquee = (props: DataMarqueeProps) => {
  const initializedProps: DataMarqueeProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return <div className={Styles['DataMarquee']}>DataMarquee</div>
}
